const CURRENCY_CLASSNAME = 'blaze-ecommerce-currency';

export { CURRENCY_CLASSNAME };
